import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import { showAlertSnackBar } from 'utils/Global';
import { licenseValidatorApi } from './licenseValidatorApi';
import LicenseService from 'business/services/LicenseService';
import { useLicenseValidatorPublicKey } from 'redux/hooks/common';
import { useEffect, useState } from 'react';
import { useRMDispatch } from 'redux/hooks';
import { setlicenseValidatorPublicKey } from 'redux/reducers/commonReducer';
import { loadConfig } from 'config';
import { CacheHelper } from 'utils/CacheHelper';

const licenseService = new LicenseService();
const cookieTitle = 'X-MachineName';

export const useValidateSeatName = () => {
  const licenseValidatorPublicKey = useLicenseValidatorPublicKey();

  const validateSeatName = async () => {
    try {
      const challenge = await licenseService.getChallenge(licenseValidatorPublicKey);
      const signedChallenge = await licenseValidatorApi.signChallenge(challenge);
      const pcName = await licenseService.verifyChallenge(signedChallenge);
      if (!pcName.isValid) {
        showAlertSnackBar(
          EAlertType.ERROR,
          ESnackBarPosition.TOP,
          `License seat could not be validated for machine: ${pcName}`,
        );

        CacheHelper.delete(cookieTitle);
        return;
      } else {
        await CacheHelper.put(cookieTitle, pcName.machineName);
      }
    } catch (e) {
      console.error('Error during license seat validation: ', e);
      CacheHelper.delete(cookieTitle);
    }
  };
  return validateSeatName;
};

export const useGetLicenseValidatorPublicKey = () => {
  const dispatch = useRMDispatch();
  useEffect(() => {
    const fetchPublicKey = async () => {
      try {
        const publicKey = await licenseValidatorApi.getPublicKey();
        dispatch(setlicenseValidatorPublicKey(publicKey));
      } catch (e) {
        console.error('Error fetching license validator public key: ', e);
      }
    };
    fetchPublicKey();
  }, []);
};

export const useFetchLicenseValidatorConfig = () => {
  useEffect(() => {
    const fetchConfig = async () => {
      try {
        await loadConfig();
      } catch (e) {
        console.error('Error fetching license validator config: ', e);
      }
    };
    fetchConfig();
  }, []);
};

export const useIsLicenseAutenticatorHealthy = () => {
  const [isHealthy, setIsHealthy] = useState<boolean>(false);

  useEffect(() => {
    async function checkHealth() {
      try {
        const data = await licenseValidatorApi.getHealth();
        setIsHealthy(data.status === 'OK');
      } catch (e) {
        console.error('Error checking License Authenticator health: ', e);
        setIsHealthy(false);
      }
    }
    checkHealth();
  }, []);

  return isHealthy;
};
